module.exports = __webpack_public_path__ + "ipetbooking/admin/img/person_background.5969a58d.svg";